import {
    DialogSize,
    RaikoBaseCardContainer,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {GameService} from "../../../serverService/gameService/GameService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import thumbnail from "../../../assets/images/uploadImage.svg"
import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../fileManager/FileManager";

export default function GameThumbnail({gameId}) {


    const [selectedAvatarUrl, setSelectedAvatarUrl] = useState("");
    const [selectedAvatarImageId, setSelectedAvatarImageId] = useState(-1);
    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);
    const [actionButtonLoading, setActionButtonLoading] = useState(false);

    const loading = new LoadingHelper(useLoadingDispatcher())

    const gameService = new GameService()

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    useEffect(() => {
        if (typeof gameService !== 'undefined') {
            getGameThumbnailFromServer()
        }
    }, [gameId]);

    function getGameThumbnailFromServer() {
        loading.show()
        gameService.getGameThumbnail(gameId)
            .then(response => {
                setSelectedAvatarUrl(response.url&& response.url.downloadUrl ? response.url.downloadUrl : "")
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateGameThumbnail() {
        setActionButtonLoading(true)
        gameService.updateGameThumbnail(gameId)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setActionButtonLoading(false                                                                                                                                       )
        })

    }

    function handleSelectPredefinedAvatar(id, url) {
        setSelectedAvatarImageId(id)
        setSelectedAvatarUrl(url)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={FileManagerTypes.GAME_THUMBNAILS.id}
                    setSelectedFileUrl={handleSelectPredefinedAvatar}
                    />

            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"تصویر شاخص"}
                        hasActionButton
                        actionButtonOnclick={handleUpdateGameThumbnail}
                        actionButtonLoadingState={actionButtonLoading}
                        actionButtonTitle={selectedAvatarUrl ? "بروزرسانی" : "افزودن"}
                    >
                        <RaikoGridOneColumn>
                            <div
                                className={"baseSelectImageContainer"}
                                onClick={handleOpenFileManager}
                            >
                                {
                                    selectedAvatarUrl && selectedAvatarUrl.length > 0 ?
                                        <img src={selectedAvatarUrl} alt=""/> :
                                        <img src={thumbnail} alt=""/>

                                }
                                <span>
                                {
                                    selectedAvatarImageId && selectedAvatarImageId >= 0 ?
                                        "برای تغییر تصویر کلیک نمایید." :
                                        "برای انتخاب تصویر کلیک نمایید."
                                }
                            </span>
                            </div>
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}